import React from 'react';
import { Navbar } from '../../components';
import { PeptWrittenHeader } from '../../containers';

const PeptWritten = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <PeptWrittenHeader />
        </div>
    </div>
  )
}

export default PeptWritten